<template>
  <div class="menu-float-left MuiDrawer-paper bg-black">
    <div class="makeStyles-toolbar-9 ">
      <b-col cols="12">
        <img class="img-auto" src="../assets/logo.png" alt="" />
      </b-col>
    </div>
    <div class="display-inline-flex padding-user">
      <div>
        <font-awesome-icon
          icon="user-circle"
          style="color:white;font-size:34px"
        />
      </div>
      <div class="padding-two-left ">
        <p style="color:white">{{ username }}</p>
      </div>
    </div>
    <div class="width-auto">
      <b-nav vertical class=" float-left width-auto">
        

        <b-button
          class="float-left btn-transparent"
          v-b-toggle="'collapse-2'"
        >
          <span class="padding-two-left"> Consultas</span>

          <span class="when-opened float-left">
            <font-awesome-icon icon="chevron-down" />
          </span>
          <span class="when-closed float-left">
            <font-awesome-icon icon="chevron-right" />
          </span>
        </b-button>
        <b-collapse id="collapse-2">
          <b-card class="bg-darkblack">
            <ul class="list-style-none color-white d-flex">
              <li>
                <router-link class="color-white nav-link" to="/search-ticket"
                  >Consulta por Ticket
                </router-link>
              </li>
              <li>
                <router-link class="color-white nav-link" to="/reports">
                  Ver Reportes
                </router-link>
              </li>
            </ul>
          </b-card>
        </b-collapse>
      </b-nav>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "SideBar",
  computed: {
    ...mapState("module", ["username", "optionsMenu"]),
    ...mapState({
      isMenuOpen: (state) => state.isMenuOpen,
    }),
    permisionMenu() {
      if (typeof this.optionsMenu !== "undefined" && this.optionsMenu) {
        return this.optionsMenu.some((data) => data.codigo == 10);
      }
      return false;
    },
    permisionMenuSearch() {
      if (typeof this.optionsMenu !== "undefined" && this.optionsMenu) {
        return this.optionsMenu.some((data) => data.codigo == 11);
      }
      return false;
    },
  },
};
</script>
<style scoped>
.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}
.card-body {
  padding: 0;
}
.d-flex {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
  flex-direction: column !important;
}
.padding-user {
  padding: 0.5rem 1rem;
}
.float-left {
  float: left;
  color: white;
}
.btn-transparent {
  background: transparent !important;
  border: none !important;
}
.btn-transparent:active {
  background: #f26d01 !important;
}
.btn-transparent:focus {
  background: #f26d01 !important;
}
.bg-darkblack {
  background: #ff7200;
}
.width-auto {
  width: 100%;
}
.router-link-active {
  background: #e06501 !important;
}

.color-white {
  color: white;
}
.list-style-none {
  list-style: none;
  margin-left: 0 !important;
  padding-left: 0 !important;
}
.MuiDrawer-paper {
  top: 0;
  flex: 1 0 auto;
  height: 100%;
  display: flex;
  outline: 0;
  z-index: 15;
  position: fixed;
  overflow-y: auto;
  flex-direction: column;
  -webkit-overflow-scrolling: touch;
  width: 240px;
  transition: width 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms;
  border-right: 1px solid rgba(0, 0, 0, 0.12);
  flex-shrink: 0;
  white-space: nowrap;
}
.makeStyles-toolbar-9 {
  display: flex;
  padding: 0px 8px;
  min-height: 68px;
  align-items: center;
  justify-content: center;
}

.bg-black {
  background: #ff7200;
}
.img-auto {
  width: 100%;
  height: auto;
  padding: 15px;
}
.display-inline-flex {
  display: inline-flex;
}
.padding-two-left {
  padding-left: 5px;
}
.float-left {
  text-align: left;
}
.nav-link {
  color: white;
  padding: 0.9rem 1rem;
}
.padding-two-left {
  padding-left: 4%;
}
ul > li {
  max-width: 100%;
}
</style>
